import FeatureUtil from '../../util/FeatureUtil';
import ProsDOMUtil from '../../util/ProsDOMUtil';


export default class HomePage {
  constructor(mainPageController) {
    this.selector = mainPageController.selector;
    this.hpMarketingZone = this.selector.filter('[data-context="HP_ZONE_E"]');
  }

  apply() {
    if (this.hpMarketingZone) {
      return new Promise((resolve) => {
        FeatureUtil.HOME_PAGE_PROS_ZONE_E_ENABLED.isEnabled().then((result) => {
          if (!result) {
            ProsDOMUtil.hide(this.hpMarketingZone);
          }
          resolve(true);
        });
      });
    }
    return Promise.resolve(true);
  }
}
